export default __webpack_public_path__ + "static/media/Pilot.c9feef21.jpg";